import { PT } from "~/utils/products";

type CalcOrderQtyParams = {
  productType?: PT | string;
  shipsFromStockLevel?: number;

  quantity?: number;
  sizing?: "I" | "O" | string;
  mouldingWidth?: number;

  // LENGTH
  linearFt?: number;

  // CHOP / JOIN
  width?: number;
  height?: number;

  // RAIL
  railLength?: number;

  // BOX
  boxFeet?: number; // feet per box (e.g., 350)
};

function inchesForPerimeterType(p: {
  width: number;
  height: number;
  quantity: number;
  sizing?: string;
  mouldingWidth: number;
}) {
  const base = p.width * 2 + p.height * 2;
  const insideExtra = p.sizing === "I" ? p.mouldingWidth * 4 : 0;
  return (base + insideExtra) * p.quantity;
}

function inchesForRailType(p: {
  railLength: number;
  quantity: number;
  sizing?: string;
  mouldingWidth: number;
}) {
  const insideExtra = p.sizing === "I" ? p.mouldingWidth * 2 : 0;
  return (p.railLength + insideExtra) * p.quantity;
}

export function calcOrderQtyInFeet(p: CalcOrderQtyParams): number {
  // TODO: Remove shipsFromStockLevel check - not needed here, ensure its being checked where it needs to be before removing..
  if (!p.productType || !p.shipsFromStockLevel || p.shipsFromStockLevel <= 0) {
    return 0;
  }

  const quantity = p.quantity ?? 1;
  const sizing = p.sizing ?? "O";
  const mouldingWidth = p.mouldingWidth ?? 0;

  const type = p.productType as PT;
  let inches = 0;

  switch (type) {
    case PT.LENGTH:
      inches = (p.linearFt ?? 0) * 12;
      break;

    case PT.CHOP:
    case PT.JOIN:
      inches = inchesForPerimeterType({
        width: p.width ?? 0,
        height: p.height ?? 0,
        quantity,
        sizing,
        mouldingWidth,
      });
      break;

    case PT.RAIL:
      inches = inchesForRailType({
        railLength: p.railLength ?? 0,
        quantity,
        sizing,
        mouldingWidth,
      });
      break;

    case PT.BOX:
      inches = (p.boxFeet ?? 0) * 12 * quantity;
      break;

    default:
      inches = 0;
  }

  return Math.ceil(inches / 12);
}
